﻿export interface IOpo {
    id: number,
    optnAlias: string,
    optnName: string,
    nkrAlias: string,
    nkrName: string,
    legalName: string,
    address: string,
    city: string,
    state: string,
    postalCode: string,
    opoRegion: number,
    executiveDirector: string,
    medicalDirector: string,
    phoneNumber: string,
    website: string,
    achRoutingNumber: string,
    achAccountNumber: string,
    isActive: boolean
}

export interface IOpoForList {
    id: number,
    nkrAlias: string,
    optnAlias: string,
    name: string,
    address: string,
    city: string,
    state: string,
    postalCode: string,
    isActive: boolean,
    achApproved: boolean,
    isCenter: boolean,
    contactCount: number,
    hasAch: boolean
}

export interface IOpoForCenterProfile {
    id: number,
    optnAlias: string,
    optnName: string,
    nkrAlias: string,
    nkrName: string
}